import {
  INTERNATIONAL_PHONE_COUNTRY,
} from '../../../i18n/i18n.language-config';
import type { LeadConvertorRequestBody } from '../types';

const DEFAULT_LAST_NAME = 'X';

export const buildLeadConvertorPayload = ({
  me,
  account,
  policy,
  riskFactors,
}: LeadConvertorRequestBody) => {
  if (!account.region) {
    throw new Error('Account region is required to build lead convertor payload');
  }

  const region = INTERNATIONAL_PHONE_COUNTRY[account.region];
  if (!region) {
    throw new Error('Region is required to build lead convertor payload');
  }

  return {
    leadPlatformId: me.account.id,
    platformCBID: account.cbid,
    region,
    userInfo: {
      firstName: me.firstName,
      lastName: me.lastName || DEFAULT_LAST_NAME, // Set to X if lastName is not provided
      email: me.email,
      phoneNumber: me.phone,
    },
    securityContactInfo: {
      firstName: account.securityContact?.firstName,
      lastName: account.securityContact?.lastName,
      email: account.securityContact?.email,
      phoneNumber: account.securityContact?.phoneNumber,
    },
    company: {
      name: account.name,
      addr1: account.address1,
      addr2: account.address2,
      city: account.city,
      state: account.state,
      postalCode: account.zipCode,
      employeeCount: account.noOfEmployeesAll,
      revenue: account.revenue,
      primaryIndustry: account.primaryIndustry,
      secondaryIndustry: account.secondaryIndustry,
      naicsCode: account.naicsCode,
      agencyId: account.agencyId,
    },
    policyNumber: policy.policyNumber,
    policyProduct: policy.product,
    factors: {
      companyAgg: riskFactors.companyAggregate,
      industryAgg: riskFactors.industryAggregate,
      networkSecurity: riskFactors.factors.networkSecurity,
      endpointSecurity: riskFactors.factors.endpointSecurity,
      cloudSecurity: riskFactors.factors.cloudSecurity,
      cyberExtortion: riskFactors.factors.cyberExtortion,
      compliance: riskFactors.factors.compliance,
      supplyChain: riskFactors.factors.supplyChain,
      fundsTransfer: riskFactors.factors.fundsTransfer,
      darkIntelligence: riskFactors.factors.darkIntelligence,
    },
  };
};
